import { createContext, useState, useEffect } from "react";
import { getRequest } from "../common/service";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const SelectSiteContext = createContext()

export { SelectSiteContext }

const SelectSite = ({ children }) => {
    const [siteId, setSiteId] = useState(null);
    const [response, setResponse] = useState([])
    const [error, setErrors] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate()


    const SelectSiteFunction = () => {
        localStorage.setItem('currentSideId', siteId)
        const site = localStorage.getItem('currentSideId')
        const urlEndPoint = `sitedetails/${site}`;
        setLoading(true)
        let cancleToken = axios.CancelToken.source();
        getRequest(urlEndPoint)
            .then((response) => {
                setResponse(response.data);
                setLoading(false)
                if (response.data) {
                    navigate("/dashboard/overview");
                } else {
                    navigate("/account/select-site");
                }
            })
            .catch((error) => {
                setErrors(error);
                setLoading(false)
                if (axios.isCancel(error)) {
                    setErrors(`request cancelled:${error.message}`);
                    setLoading(false)
                } else {
                    setErrors("another error happened:" + error.message);
                    setLoading(false)
                }
            });
        return () => {
            cancleToken.cancel("Cancelling in cleanup");
        };
    }

    function setSiteIdFunction(value) {
        setSiteId(value)
    }

    function defaultSelectedSite(siteId) {
        setSiteId(siteId)
    }

    const contextData = {
        selectedSite: response,
        loading: loading,
        error: error,
        setSiteIdFunction: setSiteIdFunction,
        defaultSelectedSite: defaultSelectedSite
    }

    useEffect(() => {
        if (siteId) {
            SelectSiteFunction()
        }
    }, [siteId])

    return (
        <SelectSiteContext.Provider value={contextData}>
            {loading ? null : children}
        </SelectSiteContext.Provider>
    )
}

export default SelectSite;